import { Environment } from '.';

/**
 * Attempts to determine the environment of Buchballs's API to use. This is used
 * in a number of endpoints such as the endpoint for translation bundles.
 * 
 * @returns { string }
 */
export function getBunchballEnv( _appEnv ) {
    return [ Environment.QA, Environment.DEV, Environment.LOCAL ].includes( _appEnv ) ? Environment.QA : _appEnv;
}
